// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import CheckOutlinedSvg from "@ant-design/icons-svg/es/asn/CheckOutlined";
import AntdIcon from '../components/AntdIcon';

var CheckOutlined = function CheckOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckOutlinedSvg
  }));
};

CheckOutlined.displayName = 'CheckOutlined';
export default React.forwardRef(CheckOutlined);